package com.crowpay.extensions


internal fun Float.toByteArray(): ByteArray = toBits().toByteArray()